<h3 matDialogTitle class="notificacao-titulo" style="background-color: #a6d4f5;">
    {{ notificacao.titulo }}
</h3>
<div mat-dialog-content>
  <!-- título destacado -->
  <!-- <h3 class="notificacao-titulo">{{ this.notificacao.titulo }}</h3> -->

  <div class="notificacao-text">
    <ng-container *ngIf="safeTexto; else plaintext">
      <div [innerHTML]="safeTexto"></div>
    </ng-container>
    <ng-template #plaintext>
      <div [innerHTML]="(notificacao?.texto || '') | nl2br"></div>
    </ng-template>
  </div>
</div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button mat-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>{{ "CLOSE" | translate }}
  </button>
</div>